import React from "react";
import {useSelector} from "react-redux";
import StaticPages from "./StaticPages";
import DynamicPages from "./DynamicPages";
import {userCan} from "../../Components/Helpers/Utils";

export default function () {
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');

  return (<>
    <h2 className="text-center mt-3 mb-4">Manage Keywords</h2>
    <div>
      {
        (isAdmin || userCan(user?.permissions, 'Static Page View')) && <StaticPages/>
      }

      {
        (isAdmin || userCan(user?.permissions, 'Page View')) && <DynamicPages/>
      }
    </div>
  </>);
}